import { render } from "./letter-tag-detail.vue?vue&type=template&id=593f8ddf"
import script from "./letter-tag-detail.vue?vue&type=script&lang=js"
export * from "./letter-tag-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__